<template>
  <div id="tanker">
    <div class="vx-row">
      <div class="content flex items-center">
        <h3 class="dark bold text-percent">{{ value.toFixed(2) }}%</h3>
        <canvas class="mx-auto" ref="canvasRef" id="draw" :width="width" :height="height" />
      </div>
    </div>
  </div>
</template>
<script>
import "./styles.css";
export default {
  name: "tanker",
  props: {
    total: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      default: 100,
    },
    active: {
      type: Boolean,
      default: false,
    },
    loadind: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 512,
    },
    height: {
      type: Number,
      default: 256,
    },
  },
  watch: {
    active(val) {
      if (val) {
        this.$vs.loading()
        setTimeout( ()=> {
          this.drawImage();
          this.$vs.loading.close()
        }, 2000);
      } else {
        this.clearRectImage();
      }
    },
    loading() {
      // loading component
    },
    count(val) {
      if (val > 1) {
        this.drawImage();
      }
    },
  },
  data() {
    return {
      percent: 0,
      imgHeight: 512,
      loading: false,
      count: 0,
      tankerImgBlank: null,
      tankerImg: null,
    };
  },
  created() {
    this.loadingImage();
  },
  methods: {
    loadingImage() {
      const imgBlank = require("./../../assets/images/elements/tanker/tanker_blank.png");
      const imgDefault = require("./../../assets/images/elements/tanker/tanker_default2.png");
      this.tankerImg = new Image();
      this.tankerImg.src = imgDefault;
      this.tankerImgBlank = new Image();
      this.tankerImgBlank.src = imgBlank;
      this.tankerImg.addEventListener("load", () => this.onLoading());
      this.tankerImgBlank.addEventListener("load", () => this.onLoading());
    },
    onLoading() {
      this.count += 1;
    },
    calcPercent() {
      // console.log(this.value , this.total);
      return this.value / this.total;
    },
    clearRectImage() {
      const canvas = this.$refs.canvasRef;
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
    },
    drawImage() {
      this.clearRectImage();
      if (this.count > 1) {
        const canvas = this.$refs.canvasRef;
        const ctx = canvas.getContext("2d");
        // const imgBlank = require("./../../assets/images/elements/tanker/tanker_0.png");
        // const imgDefault = require("./../../assets/images/elements/tanker/tanker.png");
        // 320 image height imgDefault
        // 567 image height imgBlank
        const px = 80;
        // const percent = this.value;
        const percent = this.calcPercent();
        const sc = this.tankerImg.height / this.tankerImgBlank.height;
        const imageWidth = canvas.width * 0.8;
        const imageHeight = canvas.height * 0.7;
        ctx.drawImage(
          this.tankerImgBlank,
          0,
          0,
          this.tankerImgBlank.width,
          this.tankerImgBlank.height,
          px,
          0,
          imageWidth,
          imageHeight
        );

        ctx.drawImage(
          this.tankerImg,
          0, // cx
          this.tankerImg.height - (this.tankerImg.height/2) * percent, // cx
          this.tankerImg.width, // sx
          this.tankerImg.height * percent, // sy
          px, // x
          imageHeight - (imageHeight/2) * percent * sc, // y
          imageWidth, // image width
          imageHeight * (percent * sc) // image height
        );
        // console.log(this.tankerImg.height,this.value,percent, this.tankerImg.height - (this.tankerImg.height/2) * percent);

        // ctx.beginPath();
        // ctx.fillStyle = "#efefef";
        // ctx.strokeStyle = "#efefef";
        // ctx.fillRect(20, imageHeight - imageHeight * sc, 20, imageHeight * sc);
        // ctx.stroke();

        // ctx.beginPath();
        // ctx.fillStyle = "rgb(83, 179, 142)";
        // ctx.fillRect(
        //   20,
        //   imageHeight - imageHeight * percent * sc,
        //   20,
        //   imageHeight * (percent * sc)
        // );
        // ctx.stroke();

        // // draw line
        // ctx.beginPath();
        // ctx.strokeStyle = "#3f3f3f";
        // ctx.moveTo(50, imageHeight - imageHeight * percent * sc);
        // ctx.lineTo(120, imageHeight - imageHeight * percent * sc);
        // ctx.stroke();

        // // draw percen
        // ctx.fillStyle = "#3f3f3f";
        // ctx.font = "14px Arial";
        // ctx.fillText(
        //   `${Math.floor(percent * 100)}%`,
        //   70,
        //   imageHeight - imageHeight * percent * sc - 5
        // );
        // ctx.stroke();
      }
    },
  },
};
</script>
<style scoped>
.content {
  width: 800px;
  height: 400px;
  margin: auto;
  justify-content: center;
}
.cover {
  width: 100px;
  height: 256px;
  object-fit: cover;
}
.vesselImg {
  width: 800px;
  height: 400px;
  top: 150px;
}
.frontImg {
  /* background-color: red; */
  position: absolute;
  top: 115px;
}
.card {
  width: 200px;
}
.card-container {
  justify-content: space-between;
  margin: 8px;
}
.bold {
  font-weight: bold;
}
.ruler {
  width: 800px;
}
.ruller-container {
  align-self: flex-start;
  margin-top: 24px;
}
.text-percent {
  position: absolute;
  bottom: 37%;
  right: 46%;
}
</style>
